import { Link } from 'react-router-dom';
import { liveMatches, upcomingMatches } from '@/mocks/home';

export default function LiveMatchesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-bold text-primary-500 uppercase tracking-wider">Live Now</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              实时直播赛事
            </h2>
          </div>
          <Link
            to="/category/live"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部赛事 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {liveMatches.map((match) => (
            <Link
              key={match.id}
              to={`/category/live`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <i className={`${match.leagueIcon} text-accent-500 text-sm`}></i>
                  <span className="text-xs font-medium text-foreground-500">{match.league}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                  <span className="text-xs font-bold text-primary-500">{match.minute}</span>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex flex-col items-center gap-2 flex-1">
                  <div className="w-14 h-14 rounded-full bg-background-100 overflow-hidden flex items-center justify-center">
                    <img src={match.homeLogo} alt={match.homeTeam} className="w-full h-full object-cover" />
                  </div>
                  <span className="text-sm font-bold text-foreground-800 text-center">{match.homeTeam}</span>
                </div>

                <div className="flex flex-col items-center px-4">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 tracking-wider">
                    {match.score}
                  </span>
                  <span className="text-[10px] uppercase text-primary-500 font-bold tracking-widest mt-1">live</span>
                </div>

                <div className="flex flex-col items-center gap-2 flex-1">
                  <div className="w-14 h-14 rounded-full bg-background-100 overflow-hidden flex items-center justify-center">
                    <img src={match.awayLogo} alt={match.awayTeam} className="w-full h-full object-cover" />
                  </div>
                  <span className="text-sm font-bold text-foreground-800 text-center">{match.awayTeam}</span>
                </div>
              </div>

              <div className="flex items-center justify-between mt-5 pt-4 border-t border-background-200/50">
                <div className="flex items-center gap-4 text-xs">
                  {match.drawOdds > 0 ? (
                    <>
                      <span className="text-foreground-500">主 {match.homeOdds}</span>
                      <span className="text-foreground-500">平 {match.drawOdds}</span>
                      <span className="text-foreground-500">客 {match.awayOdds}</span>
                    </>
                  ) : (
                    <>
                      <span className="text-foreground-500">主 {match.homeOdds}</span>
                      <span className="text-foreground-500">客 {match.awayOdds}</span>
                    </>
                  )}
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line text-xs"></i>
                  {(match.viewers / 10000).toFixed(0)}万
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12">
          <div className="flex items-center gap-2 mb-6">
            <i className="ri-time-line text-accent-500 text-sm"></i>
            <h3 className="font-heading text-lg font-bold text-foreground-900">即将开始</h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {upcomingMatches.map((match) => (
              <div
                key={match.id}
                className="bg-background-100/70 rounded-xl p-4 border border-background-200/50"
              >
                <div className="flex items-center gap-1.5 mb-3">
                  <span className="text-[10px] font-bold text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full">{match.league}</span>
                  <span className="text-xs text-foreground-400 ml-auto">{match.startTime.slice(5)}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-bold text-foreground-800">{match.homeTeam}</span>
                  <span className="text-xs text-foreground-400 font-bold">VS</span>
                  <span className="text-sm font-bold text-foreground-800">{match.awayTeam}</span>
                </div>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/40">
                  {match.drawOdds > 0 ? (
                    <>
                      <span className="text-xs text-foreground-500">主{match.homeOdds}</span>
                      <span className="text-xs text-foreground-500">平{match.drawOdds}</span>
                      <span className="text-xs text-foreground-500">客{match.awayOdds}</span>
                    </>
                  ) : (
                    <>
                      <span className="text-xs text-foreground-500">主{match.homeOdds}</span>
                      <span className="text-xs text-foreground-500">客{match.awayOdds}</span>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}